import { Link } from "gatsby";
import React from "react";
import { css } from "glamor";
import { propMerge } from "glamor/react";
import { colours, fadeHexToRgba } from "../../../constants/colourConstants";

const wrapperStyles = css({
    fontSize: "12px",
    marginBottom: "24px"
})

const listStyles = css({
    margin: 0,
    listStyle: "none",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
})

const crumbStyles = {
    padding: "4px 8px",
    borderRadius: "16px",
    cursor: "pointer",

    ":hover": {
        backgroundColor: fadeHexToRgba(colours.primary.greys[100], 0.08)
    }
}

const activeCrumbStyles = {
    cursor: "default",
    ":hover": {
        backgroundColor: "transparent"
    }
}

const Breadcrumbs = ({
    activePage,
    separator,
    ...otherProps
}) => {
    return (
        <nav
            {...propMerge(wrapperStyles, otherProps)}
        >
            <ol {...listStyles}>
                <li {...css(crumbStyles)}>
                    <Link to="/">
                        Home
                    </Link>
                </li>
                <li {...css({ padding: "0 2px" })}>
                    {separator ? separator : "/"}
                </li>
                <li {...css({
                    ...crumbStyles,
                    ...activeCrumbStyles,
                })}>
                    {activePage}
                </li>
            </ol>
        </nav>
    )
}

export default Breadcrumbs